import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("kb_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
    : "—";

export const CATEGORY_LABELS = { peptide: "Peptide", bac_water: "BAC Water", supply: "Supply" };

export function parseMg(s) {
  const m = String(s || "").match(/([\d.]+)\s*(mg|mcg|µg|ug)?/i);
  const n = m ? parseFloat(m[1]) : 0;
  if (!n) return null;
  return /^(mcg|µg|ug)$/i.test(m[2] || "") ? n / 1000 : n;
}

export function groupProducts(list) {
  const m = new Map();
  list.forEach((p) => {
    const g = p.group_id || p.id;
    if (!m.has(g)) m.set(g, []);
    m.get(g).push(p);
  });
  const key = (p) => parseMg(p.vial_size) ?? 0;
  return [...m.entries()].map(([id, items]) => ({ id, items: [...items].sort((a, b) => key(a) - key(b)) }));
}

export function linePreview(line, fee) {
  const unit = line.product.effective_price;
  const recon = line.reconstitute && line.product.category === "peptide";
  const reconFee = recon ? fee * line.quantity : 0;
  return { unit, recon, reconFee, total: unit * line.quantity + reconFee };
}
